"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CalcBaseItem = (function () {
    function CalcBaseItem(frequencyCapping, targeting, cpm, fixedPrice, adFormat) {
        this.frequencyCapping = frequencyCapping;
        this.targeting = targeting;
        this.cpm = cpm;
        this.fixedPrice = fixedPrice;
        this.adFormat = adFormat;
    }
    return CalcBaseItem;
}());
exports.CalcBaseItem = CalcBaseItem;
//# sourceMappingURL=calcBaseItem.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/calcBaseItem.js
// module id = 43
// module chunks = 0